export default "__VITE_ASSET__Bl9q38A6__"